import { hasUserOptedInForAnalytics, waitForEvidon } from 'hooks/useHandleEvidonCookieConsent';

function changePhoneNumberDynamically() {
  waitForEvidon().then(runInvoca);
}

function runInvoca() {
  if (!hasUserOptedInForAnalytics()) return;

  if (window.Invoca) {
    try {
      window.Invoca.PNAPI.run();
    } catch (err) {
      let msg = err.message;
      if (err.name === 'SecurityError') {
        msg += ' Cookies are most likely disabled on the browser.';
      }
      const e = new Error(msg);
      e.stack = err;
      e.name = 'InvocaLoadError';
      console.error('Unable to run Invoca', e);
    }
  }
}

export const changePhoneNumberDynamicallyAfterTimeout = () => {
  setTimeout(changePhoneNumberDynamically);
};
